function initTinyMCE(textarea) {
    tinymce.init({
        base_url: "/Scripts/tinymce",
        selector: '.js-rte',
        menubar: false,
        plugins: 'lists link ',
        toolbar: 'formatselect | bold italic |  bullist numlist | link',
        resize: false,
        width: 780,
        height: 200,
        
        setup: function (editor) {
            editor.on('change blur', function (e) {
                e.target.targetElm.value = editor.getContent();
            });
        },
        
    });
}

$(document).ready(function () {

    $(".js-rte").each(function () {

        var textarea = this;
        
        //if (tinymce in window) {
        //    initTinyMCE(textarea);
        //    return;
        //}

        $.getScript("/Scripts/tinymce/tinymce.min.js")
            .done(function () {
                initTinyMCE(textarea);
            });
    });

});

